import styled from 'styled-components';
import { Media } from '@/js/libs/ui/src/theme/Media';
export const Wrapper = styled.div `
  display: flex;
`;
export const ContentWrapper = styled.div `
  width: 100%;
  padding: 21px 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  @media ${Media.xsMax} {
    padding: 9px 12px;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;

    & > button {
      width: 100%;
    }
  }
`;
export const TitleAndFiltersWrapper = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;
export const TitleAndExpandableButtonWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  gap: 8px;
  justify-content: ${({ iconPosition }) => (iconPosition === 'left' ? 'flex-start' : 'space-between')};
`;
export const TitleWrapper = styled.div `
  padding: 3px 0px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  ${({ theme }) => theme.typography.title};
  color: ${({ theme }) => theme.colors.black_1};
`;
export const ActionsWrapper = styled.div `
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
`;
export const ExpandableButtonWrapper = styled.div `
  background-color: ${({ theme }) => theme.colors.grey00_1};
  display: flex;
  align-items: flex-start;
  justify-content: center;

  @media ${Media.smMin} {
    padding: 21px 12px;
    border-right: ${({ position, theme }) => (position === 'left' ? `1px solid ${theme.colors.grey10_1}` : 'none')};
    border-left: ${({ position, theme }) => (position === 'right' ? `1px solid ${theme.colors.grey10_1}` : 'none')};
  }
`;
